/**
 * How many stukken a dossier contains.
 *
 * `unknown` is deliberately not `ready` with a zero: a dossier the count could not be established for shows
 * nothing at all, while one that genuinely holds no stukken shows `0`. It is also what a row that is not a
 * dossier reads, since the column means nothing there.
 */
export interface StukCount {
    readonly status: 'loading' | 'ready' | 'unknown';
    readonly count: number;
}

export const LOADING_STUK_COUNT: StukCount = { status: 'loading', count: 0 };
export const UNKNOWN_STUK_COUNT: StukCount = { status: 'unknown', count: 0 };
